<template>
	<a-row class="pposition">
	  <a-col :xs="24" :sm="24" :md="12" :lg="14" :xl="14" class="pposition-breadcrumb">
		  <a-breadcrumb style="margin: 16px 0" class="breadcrumb-cls">
			<a-breadcrumb-item><a-icon type="unordered-list" /></a-breadcrumb-item>
			<template v-for="(item,index) in pplistVal">
				<template v-if="index>0">
					<a-breadcrumb-item :key="item.id" v-if="index==(pplistVal.length-1)" class="active">
						{{item.name}}
					</a-breadcrumb-item>	
					<a-breadcrumb-item :key="item.id" @click="changMenu(item.id)" v-else>
						<span @click="changMenu(item.id)">{{item.name}}</span>
					</a-breadcrumb-item>					
				</template>			
			</template>
		  </a-breadcrumb>
	  </a-col>
	  <a-col :xs="24" :sm="24" :md="12" :lg="10" :xl="10" class="search-min" >
			<div class="SearchDiv">
				<a-input placeholder="请输入关键词..." style="width: 100%" allow-clear  v-model="keywordsVal" @input="handleSearch"/>
				<span class="SearchDiv-btn">搜索</span>
			</div>
	  </a-col>
	</a-row>
</template>

<script>
import {findById,findParentPath,modifyNestedArrayById,modifyNestedArrayByKeyName,findByIdNumber} from '@/utils/util';
import { mapState,mapActions } from 'vuex';
import _ from 'lodash';

export default {
  data() {
    return {
       showVal:"", 
		keywordsVal:"",
    };
  },
  components: {
    // TyphoonInfoTreeSelect,
  },
  computed: { 
	  pplistVal(){ 
		  return this.$store.state.article.pplist;
	  },
	  seltMenuVal(){
		  return this.$store.state.article.seltMenuItem;
	  },
	  keywordsVal2(){
		  return this.$store.state.article.searchKeyWordsMin;
	  }
  },
  watch:{
	  keywordsVal2(newVal)
	  {
		  this.keywordsVal=newVal;
	  }
  },
  mounted(){
	// 初始化时绑定handleSearch到组件实例上，确保在组件销毁时取消防抖函数
	this.handleSearch = _.debounce(this.performSearch, 500);
  },
  created() {
    this.handleSearch = this.handleSearch.bind(this); // 确保handleSearch中的this指向Vue实例
	this.keywordsVal="";
  },
  methods: { 
	  changMenu(id){
		   var data=this.$store.state.article.menuList; 
		   if(id>0)
		   { 		   
			   var arr=findById(data,id);
			   //console.log(arr);
			   this.$store.commit("article/set_seltMenuItem",{id:arr.id,name:arr.name});
			   var pplist=findParentPath(data,id);
			   this.$store.commit("article/set_pplist",pplist); 
			   this.setActive3(pplist);
			   //arr['class']="active";
			   //arr['icon']="caret-down";		   										
		   }
	  },
	  
	  setActive3(pplist,setDefault=0)
	  {
		  var menuListData=this.$store.state.article.menuList;
		  menuListData=modifyNestedArrayByKeyName(menuListData,"class3","active3",function(node){
				node.class3=""
		  });
		  if(pplist.length>0)
		  {
			  var ival=pplist[pplist.length-1];			  
			  menuListData=modifyNestedArrayById(menuListData,ival.id,function(node){
				node.class3="active3"
			  });
		  }
		  
		  if(setDefault==1)
		  {
			  var defaultMenuItem=this.$store.state.article.defaultMenuItem;
			  console.log("defaultMenuItem:",defaultMenuItem);
			  menuListData=modifyNestedArrayByKeyName(menuListData,"class2","add-right-icon",function(node){
					node.class2=""
			  });
			  if(defaultMenuItem.id!=undefined && defaultMenuItem.id!=null)
			  {			  	 
				 menuListData=modifyNestedArrayById(menuListData,defaultMenuItem.id,function(node){
					node.class2="add-right-icon"
				 });
			  }
		  }
		  this.$store.commit("article/set_menuList",menuListData);
		  console.log("ppostion-setActive3----------------menuListData:",menuListData);
	  },
	  
	//小类查找
	 handleSearch: _.debounce(function() {
	      this.performSearch();
	 },800), // 延迟500毫秒执行搜索操作
	performSearch() {
		//console.log(value);
		var _self=this;
		var keywords=_self.keywordsVal.trim();
		console.log('Search query:', keywords);
		if(keywords.length>=0)
		{ 
			this.$store.commit("article/SetSearchKeyWordsMin",keywords.trim());		
		}
	},
	  beforeDestroy() {
		// 组件销毁前取消防抖函数，防止内存泄漏
		this.handleSearch.cancel();
	  },
  },
};
</script>

<style  lang="scss" scoped>
.pposition{ 
	height: 56px; 
	position: relative; margin-bottom: 17px;
	.pposition-breadcrumb{ height: 100%;}
	.breadcrumb-cls{
		color: #666;font-size: 16px;font-weight: 400; margin-left: 8px!important;
		.active{color:rgba(31, 110, 238, 1)!important ; font-weight:600;}
	} 
} 
.search-min{ text-align: right; height: 100%; position: relative; padding-right: 21px; padding-top: 12px;
	.SearchDiv{width: 260px; height: 32px; position:absolute;top: 12px; right: 23px; z-index: 0;}
	.SearchDiv-btn{ position: absolute;top: 5px;right: 10px;font-size: 14px; font-weight: 400;color: rgba(25, 26, 26, 1);}
}  
</style>
<style>
	.pposition .search-min .ant-input-affix-wrapper{width: 100%; border-color: #E2E3E7;border-radius: 20px; background-color: #fff; overflow: hidden;}
	.pposition .search-min .ant-input{width: 88%; border: unset;}
	.pposition .search-min .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled){border: unset;box-shadow: unset;}
	.pposition .search-min .ant-input:focus{border-right-width:unset;box-shadow:unset}
	
	.pposition .search-min .ant-input-group-addon{ 
		background-color: #fff; border:1px solid #E2E3E7; 
		border-left: 0px; 
		border-top-right-radius:30px;border-bottom-right-radius:30px; 
	} 
	.pposition .search-min .ant-btn-primary{
		background-color:unset;color:rgba(25, 26, 26, 1);
		font-size: 14px; border: unset; box-shadow: unset;border-radius: 100px;
	}
	.pposition .search-min .ant-input-affix-wrapper .ant-input-suffix{ right: 45px;}
	.pposition .search-min .ant-btn{ height: 30px; }
</style>